import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import OtherEditScreen from './OtherEditScreen'

function OtherEditPage() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('edit')} isExist={false} />
        <OtherEditScreen/>
    </div>
  )
}

export default OtherEditPage
